<template><div><h1 id="kapitel-8-schnittstellen" tabindex="-1"><a class="header-anchor" href="#kapitel-8-schnittstellen"><span>Kapitel 8. Schnittstellen</span></a></h1>
<p>Dieser Teil beschreibt die Schnitttsellen mit externen Systemen/Anbietern.</p>
</div></template>


